<button
    [type]="type"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel || label"
    (click)="onClick($event)"
    class="group inline-flex items-center justify-center gap-2 font-medium outline-none transition duration-200 ease-out focus-visible:ring-2 focus-visible:ring-[var(--tenant-accent)]/50 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed enabled:hover:-translate-y-0.5 enabled:active:translate-y-0 enabled:active:scale-[0.98]"
    [class.rounded-full]="rounded"
    [class.rounded-lg]="!rounded"
    [class.w-full]="fullWidth"
    [class]="variant === 'icon'
        ? 'w-10 h-10 p-0 border-0 bg-[var(--tenant-accent)] text-[var(--tenant-accent-contrast)] shadow-md shadow-[var(--tenant-accent)]/30 enabled:hover:shadow-lg enabled:hover:shadow-[var(--tenant-accent)]/40'
        : variant === 'clear'
            ? 'w-10 h-10 p-0 border-0 bg-transparent text-slate-500 enabled:hover:text-[var(--tenant-accent)] enabled:hover:bg-[var(--tenant-accent)]/10 dark:text-slate-400'
            : variant === 'outline'
                ? padding + ' border-2 border-[var(--tenant-accent)] text-[var(--tenant-accent)] bg-transparent enabled:hover:bg-[var(--tenant-accent)]/10'
                : padding + ' border-2 border-transparent bg-[var(--tenant-accent)] text-[var(--tenant-accent-contrast)] shadow-md shadow-[var(--tenant-accent)]/30 enabled:hover:shadow-lg enabled:hover:shadow-[var(--tenant-accent)]/40'"
>
    @if (icon && iconPos === 'left') {
        <i [class]="icon + ' ' + iconHoverClass"></i>
    }

    @if (label) {
        <span>{{ label }}</span>
    }

    @if (icon && iconPos === 'right') {
        <i [class]="icon + ' ' + iconHoverClass"></i>
    }
</button>